import { useEffect, useMemo, useState } from "react";
import { ICampaignMatrix } from "../types/interfaces/CampaingTypes";
import { MatrixCampaignType } from "../../../types/enums/campaign-enums";
import { useSelector } from "react-redux";


export const StepStackableServiceComponent = ({ ...props }) => {
  const campaignService = props.campaignService;
  const {
    campaignDetail,
    setCampaignDetail,
    updatedCachedVersion,
    setUpdatedCacheVersion,
    saveCampaignForm,
    advanceToNextStep,
  } = campaignService;

  const liveCampaignStore = useSelector((state: any) => state.campaignLiveCampaign);
  
  const [matrixes, setMatrixes] = useState<ICampaignMatrix[]>([]);

  const dontMergeList : ICampaignMatrix[] = useMemo(() => { 
    const _priorities = [...campaignDetail.priorities];
    const _matrixes = matrixes
        .filter((x: any) => x.isCombinable === MatrixCampaignType.DontMerge && (liveCampaignStore.data === -1 ? x.status !== -1 : x.status === liveCampaignStore.data))
        .map((x: any) => {
          return {
            ...x,
            processOrder: _priorities.find((p: any) => p.id === x.campaignRuleId)?.processOrder,
          };
        })
        .sort((a, b) => a.processOrder - b.processOrder);

    return _matrixes;
  }, [matrixes, liveCampaignStore]);

  const mergedList : ICampaignMatrix[] = useMemo(() => { 
    const _priorities = [...campaignDetail.priorities];
    const _matrixes = matrixes
        .filter((x: any) => x.isCombinable === MatrixCampaignType.Merged && (liveCampaignStore.data === -1 ? x.status !== -1 : x.status === liveCampaignStore.data))
        .map((x: any) => {
          return {
            ...x,
            processOrder: _priorities.find((p: any) => p.id === x.campaignRuleId)?.processOrder,
          };
        })
        .sort((a, b) => a.processOrder - b.processOrder);

    return _matrixes;
  }, [matrixes, liveCampaignStore]);

  const dontApplySameProductList : ICampaignMatrix[] = useMemo(() => { 
    const _priorities = [...campaignDetail.priorities];
    const _matrixes = matrixes
        .filter((x: any) => x.isCombinable === MatrixCampaignType.DontApplySameProducts && (liveCampaignStore.data === -1 ? x.status !== -1 : x.status === liveCampaignStore.data))
        .map((x: any) => {
          return {
            ...x,
            processOrder: _priorities.find((p: any) => p.id === x.campaignRuleId)?.processOrder,
          };
        })
        .sort((a, b) => a.processOrder - b.processOrder);

    return _matrixes;
  }, [matrixes, liveCampaignStore]);

  const getCampaignMatrixes = () => {
    setMatrixes(campaignDetail.matrixes);
  };

  useEffect(() => {
    if (campaignDetail != undefined && Object.keys(campaignDetail).length > 0) {
      getCampaignMatrixes();
    }
  }, [campaignDetail]);

  const moveCampaign = (
    targetCombinable: number,
    selectedMatrixes: number[]
  ) => {
    let _matrixes = [...matrixes];

    selectedMatrixes.map((x) => {
      updateMatrixes(x, targetCombinable, _matrixes);
    });

    setMatrixes(_matrixes);

    setCampaignDetail({
      ...campaignDetail,
      matrixes: _matrixes,
    });

    setUpdatedCacheVersion({
      ...updatedCachedVersion,
      reloadAllCampaignRuleMatrix: true,
    });
  };

  const updateMatrixes = (id: number, targetCombinable: number, array: any) => {
    const _index = matrixes.findIndex((m) => m.campaignRuleId === id);
    if (_index !== -1) {
      array[_index] = {
        ...array[_index],
        isCombinable: targetCombinable,
      };
    }
  };

  const saveForm = async (event: any) => {
    event.preventDefault();

    const saveResult = await saveCampaignForm({});
    if (saveResult) {
      advanceToNextStep();
    }
  };

  return {
    ...campaignService,
    matrixes,
    dontMergeList,
    mergedList,
    dontApplySameProductList,
    moveCampaign,
    saveForm,
  };
};
